import { stage as stageEnum } from '../enums';
import { getStartEndOfLines } from './start-end';
import { ILine as Line } from '../../global';
import cloneDeep from 'lodash.clonedeep';

export function getLineTotal(line: Line) {
  const lineCopy = cloneDeep(line);
  const stages = lineCopy.stages.filter(
    (stage) =>
      !stage.deleted &&
      stage.name !== stageEnum.complete.value &&
      stage.name !== stageEnum.repaymentsStart.value,
  );
  const total = stages.reduce((total, stage) => {
    return (total += stage.amount);
  }, 0);
  return total;
}

export function getNumMonthsOfLine(line: Line) {
  const { start, end } = getStartEndOfLines([line]);
  return Math.round(end.diff(start, 'months', true));
}
